import React from "react";

/**
 * Official Apple logo silhouette — universally reliable SVG.
 * Renders the canonical Apple Inc. mark (apple with bite + leaf).
 * Use `currentColor` for fill — color via parent's text color.
 */
export const AppleLogo = ({ className = "h-4 w-4", strokeColor }) => (
  <svg
    viewBox="0 0 170 170"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
  >
    <path
      d="M150.37 130.25c-2.45 5.66-5.35 10.87-8.71 15.66-4.58 6.53-8.33 11.05-11.22 13.56-4.48 4.12-9.28 6.23-14.42 6.35-3.69 0-8.14-1.05-13.32-3.18-5.197-2.12-9.973-3.17-14.34-3.17-4.58 0-9.492 1.05-14.746 3.17-5.266 2.13-9.51 3.24-12.742 3.35-4.929.21-9.842-1.96-14.746-6.52-3.13-2.73-7.045-7.41-11.735-14.04-5.032-7.08-9.169-15.29-12.41-24.65-3.471-10.11-5.211-19.9-5.211-29.378 0-10.857 2.346-20.221 7.045-28.068 3.693-6.303 8.606-11.275 14.755-14.925s12.793-5.51 19.948-5.629c3.915 0 9.049 1.211 15.429 3.591 6.362 2.388 10.443 3.599 12.221 3.599 1.33 0 5.864-1.417 13.55-4.239 7.269-2.618 13.41-3.702 18.444-3.275 13.64 1.101 23.888 6.478 30.706 16.166-12.197 7.394-18.231 17.752-18.111 31.06.111 10.367 3.872 18.997 11.265 25.86 3.351 3.181 7.093 5.638 11.265 7.378-.85 2.46-1.737 4.812-2.674 7.074zm-30.842-93.617c0 8.235-3.009 15.927-9.013 23.06-7.247 8.485-16.013 13.388-25.519 12.616-.121-.988-.191-2.028-.191-3.121 0-7.906 3.446-16.391 9.582-23.328 3.063-3.516 6.96-6.439 11.689-8.769 4.719-2.296 9.183-3.566 13.38-3.79.123 1.114.172 2.228.172 3.332z"
      fill="currentColor"
      stroke={strokeColor}
      strokeWidth={strokeColor ? 0.5 : 0}
    />
  </svg>
);

export default AppleLogo;
